/* eslint-disable */
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components
import withStyles from "material-ui/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import SectionCarousel from "./UI/SectionCarousel";

import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
// core components
import downloadStyle from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.jsx";

import stamp from "assets/img/Logos/stamp.svg";

import Divider from 'material-ui/Divider';

class SectionContent extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer className={classes.textLeft} justify="center">
          <GridItem xs={12} sm={12} md={8}>
              <h2><strong>Jochgem van Delft</strong></h2>
              <h4>
              <strong>Bali</strong>, Indonesia | +62 812 3741 3581
              </h4>
              <h4>
              <strong>Amersfoort</strong>, The Netherlands | +31 655 456 933
              </h4>
              <h4>
                <a href="mailto:jvandelft@pixsells.nl"><strong>jvandelft@pixsells.nl</strong></a>
              </h4>
            </GridItem>
            </GridContainer>
            <br />
            <GridContainer className={classes.textLeft} justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h3><strong>React.js Application <small>and</small> UI/UX Developer</strong></h3>
              <Divider />
              <br />
              <h4>My career began in The Netherlands doing Graphic Design and creating Cinema4D 3D
              stills and animations for advertising and branding companies. In 2008 I moved to 
              Southeast Asia where I taught myself to lecture large groups of people and started
              a career after in Real Estate consultancy. I saw many possibilities in the IT industry,
              so made a move into coding and designing UI's and UX's. </h4>
              <h4>In my life I've travelled to many places, met numerous people from all over the world and 
              developed many different skills. Doing this, makes me a complete human being. Always eager to 
              be the best in everything I do. </h4>
              <h4>Besides that, I care deeply about the people I work with. I bring empathy and 
              strong communication to teams, and strive to learn and teach as much as I can.</h4>
            </GridItem>
          </GridContainer>
          <br />
          <GridContainer className={classes.textLeft} justify="center">
          <GridItem xs={12} sm={12} md={8}>
              <h3><strong>Experience</strong></h3>
              <Divider />
              <br />
              <h5><strong>Front-End Developer</strong> Pixsells New Internet, (May 2017 - Present)</h5>
              <p>Javascript ES6, React.js / Redux, CSS3/CSS modules, HTML5, Node.js, Next.js, Git(Hub), Bootstrap4, PostgreSQL, Express.js, Solidity.</p>
              <ul>
                <li>Founded Pixsells New Internet (pixsells.nl). As the sole developer took it from the first line of 
                code to customers and revenue.</li>
                <br />
                <li>Responsible for all aspects of architecture, development, test strategy and deployment.</li>
                <br />
                <li>Hired and mentored interns and junior developers for Project SEA.</li>
                <br />
                <li>Also involved in pitching, fundraising, customer development, marketing, sales and support.</li>
              </ul>
              <br />
              <h5><strong>Momentum Stock Trader / Risk Manager</strong> Independent Trader, (Feb 2017 - Present)</h5>
              <p>I got familiar with sub $10 US stocks and Cryptocurrencies while trading fulltime on 
              the US Stock exchanges. Blockchain technology slowly found my interest, so developing smart contracts
              was an easy stap to make.</p>
            </GridItem>
          </GridContainer>
          <br />
          <GridContainer className={classes.textLeft} justify="center">
          <GridItem xs={12} sm={12} md={8}>
              <h3><strong>Education</strong></h3>
              <Divider />
              <br />
              <h5><strong>Delft University of Technology</strong> (1996 - 2000)</h5>
              <p>Engineer's Degree, Industrial Design Engineering</p>
            </GridItem>
          </GridContainer>
          <br />
          <GridContainer className={classes.textCenter} justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <img
                    src={stamp}
                    alt="Pixsells_Logo"
                    />
            </GridItem>
          </GridContainer>
          <GridContainer className={classes.textLeft} justify="center">
          <GridItem xs={12} sm={12} md={8}>
              <h2><strong>Why Bali?</strong></h2>
            </GridItem>
            </GridContainer>
            <br />
            <GridContainer className={classes.textLeft} justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h3><strong>Bali is one of the best places in the entire world to run your business remotely.</strong></h3>
              <Divider />
              <br />
              <h4>Having lived and worked in Thailand and Malaysia for many years,
              I have chosen Bali to become my headquarters. Bali with its gorgeous
              ricefields, people and equatorial climate makes it a spiritual haven
              to join a revolutionary lifestyle. It's also a place where the Balinese
              and international community closely come together to engage with each other.</h4>
              <h4>Bali's astounding natural beauty amazes visitors all year round, many
              of whom decide to make it their temporary and sometimes permanent homeground.</h4>
            </GridItem>    
          </GridContainer>
          <SectionCarousel />
          <div className={classes.textCenter + " " + classes.sharingArea}>
            <GridContainer justify="center">
              <h5><strong>Have a look here for more on LinkedIn and GitHub</strong></h5>
            </GridContainer>
            <Button 
            color="twitter"
            href="https://www.linkedin.com/in/jochgem-van-delft-28477b51/"
            target="_blank">
              <i className={classes.socials + " fab fa-linkedin"} /> LinkedIn
            </Button>
            <Button 
            color="github"
            href="https://github.com/Joevdelft"
            target="_blank">
              <i className={classes.socials + " fab fa-github"} /> GitHub
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(downloadStyle)(SectionContent);



// WEBPACK FOOTER //
// ./src/views/MyStoryPage/Sections/SectionContent.jsx